  async function loadFooter() {
    const mount = document.getElementById('footer-placeholder');
    if (!mount) return;

    try {
        const res = await fetch('./components/footer.html');
        if (!res.ok) throw new Error(res.statusText);
        
        const htmlText = await res.text();
        
        // 1. Inject all HTML content directly (This renders the layout instantly)
        mount.innerHTML = htmlText;
        
        // 2. Find and execute any scripts inside the injected container
        mount.querySelectorAll('script').forEach(oldScript => {
            const newScript = document.createElement('script');
            newScript.textContent = oldScript.textContent;
            document.body.appendChild(newScript);
        });

    } catch (err) {
        console.error('Footer load failed:', err);
    }
}

// Make sure it runs when the page loads
loadFooter();